import * as React from 'react';
import { CurrentLocationIdType } from '../current-location-route-state-context';

export type CurrentLocationRouteDispatchContextType =
    | ((newLocationId: CurrentLocationIdType) => void)
    | undefined;

export const CurrentLocationRouteDispatchContext = React.createContext<CurrentLocationRouteDispatchContextType>(undefined);
CurrentLocationRouteDispatchContext.displayName = 'CurrentLocationRouteDispatchContext';
